export default class Frame {
  constructor(data) {
    const defaults = {
      frameNumber: 1,
      pathTemplate: null,
      staticPathTemplate: null,
      testPathTemplate: null,
      desktopImgproxySettings: [],
      mobileImgproxySettings: [],
      useMobileImages: true,
      loadOnConstruct: true,
      useStaticPathTemplate: false,
      useTestPathTemplate: false
    }

    Object.assign(this, defaults, data)

    if (this.loadOnConstruct) this._loadImage()
  }

  get imgproxySettings() {
    return this.useMobileImages
      ? this.mobileImgproxySettings
      : this.desktopImgproxySettings
  }

  get path() {
    let pathTemplate = this.pathTemplate

    if (this.useStaticPathTemplate && this.staticPathTemplate) {
      pathTemplate = this.staticPathTemplate
    }

    if (this.useTestPathTemplate && this.testPathTemplate) {
      pathTemplate = this.testPathTemplate
    }

    if (!pathTemplate) return null

    const parts = [
      ...this.imgproxySettings,
      pathTemplate
        ?.replace('{nnn}', `${this.frameNumber}`.padStart(3, 0))
        ?.replace('{nn}', `${this.frameNumber}`.padStart(2, 0)),
    ]
    let url = new URL(parts.join('/'), 'https://360.sungod-assets.com/').href

    if (this.imageSizeOverride)
      url = url.replace(/fill:\d+\//, `fill:${this.imageSizeOverride}/`)

    return url
  }

  _loadImage(retries = 5) {
    if (!this.pathTemplate || this.disabled) return

    this.loaded = false
    this.img = new Image()
    this.img.onload = () => {
      this.loaded = true
      this.eventBus.emit('load', this.id)
    }
    this.img.onerror = () => {
      if (retries > 0) {
        this._loadImage(retries - 1)
      }
    }

    this.img.src = this.path
  }
}
